import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
} from '@coreui/react-pro';
import { popAlert } from 'src/store';

const AppAlert = () => {
  const dispatch = useDispatch();
  const alert = useSelector((state) => state.app.alerts[0]);
  const [show, setShow] = useState(true);
  const [disabled, setDisabled] = useState(false);
  const handleAlertAction = async (cb) => {
    if (cb) {
      setDisabled(true);
      await cb();
      setDisabled(false);
    }
    setShow(false);
  };
  const handleAlertModalClosed = () => {
    dispatch(popAlert());
    setShow(true);
  };

  if (!alert) {
    return null;
  }

  return (
    <CModal
      scrollable
      visible={show}
      onClose={handleAlertModalClosed}
      backdrop={!disabled}
      color={alert.type || 'danger'}
    >
      <CModalHeader closeButton={!disabled}>{alert.title}</CModalHeader>
      <CModalBody className="text-center">
        <h5>{alert.description}</h5>
      </CModalBody>
      <CModalFooter>
        <CButton
          className="text-uppercase"
          disabled={disabled}
          variant="outline"
          color={alert.type || 'danger'}
          onClick={() => handleAlertAction(alert.onConfirm)}
        >
          Confirm
        </CButton>
        <CButton
          className="text-uppercase"
          disabled={disabled}
          color="light"
          onClick={() => handleAlertAction(alert.onCancel)}
        >
          Cancel
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default AppAlert;
